import React from 'react';
import {
  Abc as AbcIcon,
  AccessTime as AccessTimeIcon,
  AccountTree as AccountTreeIcon,
  Add as AddIcon,
  AddCircle as AddCircleIcon,
  Anchor as AnchorIcon,
  Apartment as ApartmentIcon,
  Archive as ArchiveIcon,
  ArrowBack as ArrowBackIcon,
  ArrowDownward as ArrowDownwardIcon,
  ArrowDropDown as ArrowDropDownIcon,
  ArrowDropUp as ArrowDropUpIcon,
  ArrowForward as ArrowForwardIcon,
  ArrowUpward as ArrowUpwardIcon,
  ArticleOutlined as ArticleOutlinedIcon,
  Assessment as AssessmentIcon,
  AssessmentOutlined as AssessmentOutlinedIcon,
  Assistant as AssistantIcon,
  AttachMoney as AttachMoneyIcon,
  AutoAwesome as AutoAwesomeIcon,
  BackupOutlined as BackupOutlinedIcon,
  BarChart as BarChartIcon,
  BarChartOutlined as BarChartOutlinedIcon,
  Bookmark as BookmarkIcon,
  BookmarkAdd as BookmarkAddIcon,
  BookmarkBorder as BookmarkBorderIcon,
  BookmarkRemove as BookmarkRemoveIcon,
  Bookmarks as BookmarksIcon,
  BookmarksOutlined as BookmarksOutlinedIcon,
  Business as BusinessIcon,
  CalendarToday as CalendarTodayIcon,
  Cancel as CancelIcon,
  Category as CategoryIcon,
  CenterFocusStrongOutlined as CenterFocusStrongOutlinedIcon,
  Check as CheckIcon,
  CheckBox as CheckBoxIcon,
  CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
  CheckCircle as CheckCircleIcon,
  CheckCircleOutline as CheckCircleOutlineIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  Clear as ClearIcon,
  Close as CloseIcon,
  CloudDownload as CloudDownloadIcon,
  CloudDownloadOutlined as CloudDownloadOutlinedIcon,
  CloudSync as CloudSyncIcon,
  CloudUpload as CloudUploadIcon,
  CloudUploadOutlined as CloudUploadOutlinedIcon,
  Code as CodeIcon,
  CommentOutlined as CommentOutlinedIcon,
  CompareArrows as CompareArrowsIcon,
  ContentPaste as ContentPasteIcon,
  Dashboard as DashboardIcon,
  Delete as DeleteIcon,
  DeleteOutline as DeleteOutlineIcon,
  DensityLarge as DensityLargeIcon,
  DensityMedium as DensityMediumIcon,
  DensitySmall as DensitySmallIcon,
  Description as DescriptionIcon,
  DesktopMac as DesktopMacIcon,
  DesktopMacOutlined as DesktopMacOutlinedIcon,
  Details as DetailsIcon,
  DragHandle as DragHandleIcon,
  Edit as EditIcon,
  ElectricBolt as ElectricBoltIcon,
  Equalizer as EqualizerIcon,
  Error as ErrorIcon,
  ErrorOutline as ErrorOutlineIcon,
  ErrorRounded as ErrorRoundedIcon,
  Event as EventIcon,
  ExitToApp as ExitToAppIcon,
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
  Extension as ExtensionIcon,
  Favorite as FavoriteIcon,
  FeedbackOutlined as FeedbackOutlinedIcon,
  FileCopyOutlined as FileCopyOutlinedIcon,
  FileDownload as FileDownloadIcon,
  FilterAlt as FilterAltIcon,
  FilterList as FilterListIcon,
  FirstPage as FirstPageIcon,
  FormatAlignCenter as FormatAlignCenterIcon,
  FormatAlignLeft as FormatAlignLeftIcon,
  FormatAlignRight as FormatAlignRightIcon,
  FormatBold as FormatBoldIcon,
  FormatItalic as FormatItalicIcon,
  FormatListBulleted as FormatListBulletedIcon,
  FormatListBulletedOutlined as FormatListBulletedOutlinedIcon,
  FormatListNumbered as FormatListNumberedIcon,
  FormatListNumberedOutlined as FormatListNumberedOutlinedIcon,
  FormatQuote as FormatQuoteIcon,
  FormatSize as FormatSizeIcon,
  FormatUnderlined as FormatUnderlinedIcon,
  ForumOutlined as ForumOutlinedIcon,
  Fullscreen as FullscreenIcon,
  FullscreenExit as FullscreenExitIcon,
  GetApp as GetAppIcon,
  Grain as GrainIcon,
  GraphicEq as GraphicEqIcon,
  GridView as GridViewIcon,
  Help as HelpIcon,
  HelpOutline as HelpOutlineIcon,
  HelpOutlineRounded as HelpOutlineRoundedIcon,
  Highlight as HighlightIcon,
  HighlightOff as HighlightOffIcon,
  History as HistoryIcon,
  Home as HomeIcon,
  HomeOutlined as HomeOutlinedIcon,
  HourglassEmpty as HourglassEmptyIcon,
  ImportContacts as ImportContactsIcon,
  InfoOutlined as InfoOutlinedIcon,
  Insights as InsightsIcon,
  InsightsOutlined as InsightsOutlinedIcon,
  JoinInner as JoinInnerIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowRight as KeyboardArrowRightIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
  KeyboardDoubleArrowLeft as KeyboardDoubleArrowLeftIcon,
  KeyboardDoubleArrowRight as KeyboardDoubleArrowRightIcon,
  Label as LabelIcon,
  Language as LanguageIcon,
  LastPage as LastPageIcon,
  LibraryBooksRounded as LibraryBooksRoundedIcon,
  LightbulbCircleOutlined as LightbulbCircleOutlinedIcon,
  LightbulbSharp as LightbulbSharpIcon,
  Link as LinkIcon,
  LinkOff as LinkOffIcon,
  List as ListIcon,
  LiveHelp as LiveHelpIcon,
  Lock as LockIcon,
  LockOpen as LockOpenIcon,
  LockOutlined as LockOutlinedIcon,
  LogoutOutlined as LogoutOutlinedIcon,
  Menu as MenuIcon,
  Merge as MergeIcon,
  Message as MessageIcon,
  MoreHoriz as MoreHorizIcon,
  MoreVert as MoreVertIcon,
  MyLocation as MyLocationIcon,
  Newspaper as NewspaperIcon,
  Note as NoteIcon,
  OpenInBrowser as OpenInBrowserIcon,
  OpenInFull as OpenInFullIcon,
  OpenInNew as OpenInNewIcon,
  Palette as PaletteIcon,
  PermDataSetting as PermDataSettingIcon,
  Person as PersonIcon,
  PersonOutlined as PersonOutlinedIcon,
  PieChart as PieChartIcon,
  PlaylistAdd as PlaylistAddIcon,
  PollRounded as PollRoundedIcon,
  PowerSettingsNew as PowerSettingsNewIcon,
  PublicOutlined as PublicOutlinedIcon,
  PublishedWithChanges as PublishedWithChangesIcon,
  PublishedWithChangesOutlined as PublishedWithChangesOutlinedIcon,
  RateReview as RateReviewIcon,
  Refresh as RefreshIcon,
  Remove as RemoveIcon,
  Reorder as ReorderIcon,
  ReorderOutlined as ReorderOutlinedIcon,
  RocketLaunch as RocketLaunchIcon,
  RocketLaunchOutlined as RocketLaunchOutlinedIcon,
  SaveAlt as SaveAltIcon,
  School as SchoolIcon,
  Science as ScienceIcon,
  Search as SearchIcon,
  Send as SendIcon,
  Settings as SettingsIcon,
  SettingsBackupRestore as SettingsBackupRestoreIcon,
  SettingsOutlined as SettingsOutlinedIcon,
  Share as ShareIcon,
  ShoppingBasket as ShoppingBasketIcon,
  ShowChart as ShowChartIcon,
  Sort as SortIcon,
  SortByAlpha as SortByAlphaIcon,
  Speed as SpeedIcon,
  StackedLineChart as StackedLineChartIcon,
  Star as StarIcon,
  StarBorder as StarBorderIcon,
  StopCircle as StopCircleIcon,
  Storage as StorageIcon,
  StorageOutlined as StorageOutlinedIcon,
  Subject as SubjectIcon,
  SwapHoriz as SwapHorizIcon,
  SwapVert as SwapVertIcon,
  SyncAlt as SyncAltIcon,
  SyncProblem as SyncProblemIcon,
  Timeline as TimelineIcon,
  Title as TitleIcon,
  Tour as TourIcon,
  TourOutlined as TourOutlinedIcon,
  TrackChanges as TrackChangesIcon,
  TrendingUp as TrendingUpIcon,
  Tune as TuneIcon,
  Update as UpdateIcon,
  Upload as UploadIcon,
  VideoLibrary as VideoLibraryIcon,
  ViewColumn as ViewColumnIcon,
  ViewInAr as ViewInArIcon,
  ViewList as ViewListIcon,
  ViewModule as ViewModuleIcon,
  ViewSidebar as ViewSidebarIcon,
  VisibilityOffRounded as VisibilityOffRoundedIcon,
  VisibilityRounded as VisibilityRoundedIcon,
  VpnKey as VpnKeyIcon,
  WarningOutlined as WarningOutlinedIcon,
  WifiOff as WifiOffIcon,
  WorkOutlined as WorkOutlinedIcon,
} from '@mui/icons-material';
import type { SvgIconProps } from '@mui/material';

type IconPropsWithTestId = SvgIconProps & {
  'data-testid'?: string;
};

/**
 * Wraps a Material UI icon component to automatically add data-testid attribute.
 * The data-testid follows the pattern: iconName + "Icon" (e.g., "StarBorderIcon", "StarIcon")
 * This is because with the latest version of material UI, they removed data-testid from the icons.
 * Related issue: https://github.com/mui/material-ui/issues/45777
 * This is a temporary solution and won't be needed if they merge this PR: https://github.com/mui/material-ui/pull/45766
 */
function withTestId<T extends React.ComponentType<SvgIconProps>>(IconComponent: T, iconName: string): T {
  const WrappedIcon = React.forwardRef<SVGSVGElement, IconPropsWithTestId>((props, ref) => {
    const { 'data-testid': existingTestId, ...restProps } = props;
    const testId = existingTestId || `${iconName}Icon`;

    return React.createElement(IconComponent, {
      ...restProps,
      'data-testid': testId,
      ref,
    } as SvgIconProps & { ref: React.Ref<SVGSVGElement> });
  }) as unknown as T;

  WrappedIcon.displayName = `withTestId(${iconName})`;

  return WrappedIcon;
}

export const Abc = withTestId(AbcIcon, 'Abc');
export const AccessTime = withTestId(AccessTimeIcon, 'AccessTime');
export const AccountTree = withTestId(AccountTreeIcon, 'AccountTree');
export const Add = withTestId(AddIcon, 'Add');
export const AddCircle = withTestId(AddCircleIcon, 'AddCircle');
export const Anchor = withTestId(AnchorIcon, 'Anchor');
export const Apartment = withTestId(ApartmentIcon, 'Apartment');
export const Archive = withTestId(ArchiveIcon, 'Archive');
export const ArrowBack = withTestId(ArrowBackIcon, 'ArrowBack');
export const ArrowDownward = withTestId(ArrowDownwardIcon, 'ArrowDownward');
export const ArrowDropDown = withTestId(ArrowDropDownIcon, 'ArrowDropDown');
export const ArrowDropUp = withTestId(ArrowDropUpIcon, 'ArrowDropUp');
export const ArrowForward = withTestId(ArrowForwardIcon, 'ArrowForward');
export const ArrowUpward = withTestId(ArrowUpwardIcon, 'ArrowUpward');
export const ArticleOutlined = withTestId(ArticleOutlinedIcon, 'ArticleOutlined');
export const Assessment = withTestId(AssessmentIcon, 'Assessment');
export const AssessmentOutlined = withTestId(AssessmentOutlinedIcon, 'AssessmentOutlined');
export const Assistant = withTestId(AssistantIcon, 'Assistant');
export const AttachMoney = withTestId(AttachMoneyIcon, 'AttachMoney');
export const AutoAwesome = withTestId(AutoAwesomeIcon, 'AutoAwesome');
export const BackupOutlined = withTestId(BackupOutlinedIcon, 'BackupOutlined');
export const BarChart = withTestId(BarChartIcon, 'BarChart');
export const BarChartOutlined = withTestId(BarChartOutlinedIcon, 'BarChartOutlined');
export const Bookmark = withTestId(BookmarkIcon, 'Bookmark');
export const BookmarkAdd = withTestId(BookmarkAddIcon, 'BookmarkAdd');
export const BookmarkBorder = withTestId(BookmarkBorderIcon, 'BookmarkBorder');
export const BookmarkRemove = withTestId(BookmarkRemoveIcon, 'BookmarkRemove');
export const Bookmarks = withTestId(BookmarksIcon, 'Bookmarks');
export const BookmarksOutlined = withTestId(BookmarksOutlinedIcon, 'BookmarksOutlined');
export const Business = withTestId(BusinessIcon, 'Business');
export const CalendarToday = withTestId(CalendarTodayIcon, 'CalendarToday');
export const Cancel = withTestId(CancelIcon, 'Cancel');
export const Category = withTestId(CategoryIcon, 'Category');
export const CenterFocusStrongOutlined = withTestId(CenterFocusStrongOutlinedIcon, 'CenterFocusStrongOutlined');
export const Check = withTestId(CheckIcon, 'Check');
export const CheckBox = withTestId(CheckBoxIcon, 'CheckBox');
export const CheckBoxOutlineBlank = withTestId(CheckBoxOutlineBlankIcon, 'CheckBoxOutlineBlank');
export const CheckCircle = withTestId(CheckCircleIcon, 'CheckCircle');
export const CheckCircleOutline = withTestId(CheckCircleOutlineIcon, 'CheckCircleOutline');
export const ChevronLeft = withTestId(ChevronLeftIcon, 'ChevronLeft');
export const ChevronRight = withTestId(ChevronRightIcon, 'ChevronRight');
export const Clear = withTestId(ClearIcon, 'Clear');
export const Close = withTestId(CloseIcon, 'Close');
export const CloudDownload = withTestId(CloudDownloadIcon, 'CloudDownload');
export const CloudDownloadOutlined = withTestId(CloudDownloadOutlinedIcon, 'CloudDownloadOutlined');
export const CloudSync = withTestId(CloudSyncIcon, 'CloudSync');
export const CloudUpload = withTestId(CloudUploadIcon, 'CloudUpload');
export const CloudUploadOutlined = withTestId(CloudUploadOutlinedIcon, 'CloudUploadOutlined');
export const Code = withTestId(CodeIcon, 'Code');
export const CommentOutlined = withTestId(CommentOutlinedIcon, 'CommentOutlined');
export const CompareArrows = withTestId(CompareArrowsIcon, 'CompareArrows');
export const ContentPaste = withTestId(ContentPasteIcon, 'ContentPaste');
export const Dashboard = withTestId(DashboardIcon, 'Dashboard');
export const Delete = withTestId(DeleteIcon, 'Delete');
export const DeleteOutline = withTestId(DeleteOutlineIcon, 'DeleteOutline');
export const DensityLarge = withTestId(DensityLargeIcon, 'DensityLarge');
export const DensityMedium = withTestId(DensityMediumIcon, 'DensityMedium');
export const DensitySmall = withTestId(DensitySmallIcon, 'DensitySmall');
export const Description = withTestId(DescriptionIcon, 'Description');
export const DesktopMac = withTestId(DesktopMacIcon, 'DesktopMac');
export const DesktopMacOutlined = withTestId(DesktopMacOutlinedIcon, 'DesktopMacOutlined');
export const Details = withTestId(DetailsIcon, 'Details');
export const DragHandle = withTestId(DragHandleIcon, 'DragHandle');
export const Edit = withTestId(EditIcon, 'Edit');
export const ElectricBolt = withTestId(ElectricBoltIcon, 'ElectricBolt');
export const Equalizer = withTestId(EqualizerIcon, 'Equalizer');
export const Error = withTestId(ErrorIcon, 'Error');
export const ErrorOutline = withTestId(ErrorOutlineIcon, 'ErrorOutline');
export const ErrorRounded = withTestId(ErrorRoundedIcon, 'ErrorRounded');
export const Event = withTestId(EventIcon, 'Event');
export const ExitToApp = withTestId(ExitToAppIcon, 'ExitToApp');
export const ExpandLess = withTestId(ExpandLessIcon, 'ExpandLess');
export const ExpandMore = withTestId(ExpandMoreIcon, 'ExpandMore');
export const Extension = withTestId(ExtensionIcon, 'Extension');
export const Favorite = withTestId(FavoriteIcon, 'Favorite');
export const FeedbackOutlined = withTestId(FeedbackOutlinedIcon, 'FeedbackOutlined');
export const FileCopyOutlined = withTestId(FileCopyOutlinedIcon, 'FileCopyOutlined');
export const FileDownload = withTestId(FileDownloadIcon, 'FileDownload');
export const FilterAlt = withTestId(FilterAltIcon, 'FilterAlt');
export const FilterList = withTestId(FilterListIcon, 'FilterList');
export const FirstPage = withTestId(FirstPageIcon, 'FirstPage');
export const FormatAlignCenter = withTestId(FormatAlignCenterIcon, 'FormatAlignCenter');
export const FormatAlignLeft = withTestId(FormatAlignLeftIcon, 'FormatAlignLeft');
export const FormatAlignRight = withTestId(FormatAlignRightIcon, 'FormatAlignRight');
export const FormatBold = withTestId(FormatBoldIcon, 'FormatBold');
export const FormatItalic = withTestId(FormatItalicIcon, 'FormatItalic');
export const FormatListBulleted = withTestId(FormatListBulletedIcon, 'FormatListBulleted');
export const FormatListBulletedOutlined = withTestId(FormatListBulletedOutlinedIcon, 'FormatListBulletedOutlined');
export const FormatListNumbered = withTestId(FormatListNumberedIcon, 'FormatListNumbered');
export const FormatListNumberedOutlined = withTestId(FormatListNumberedOutlinedIcon, 'FormatListNumberedOutlined');
export const FormatQuote = withTestId(FormatQuoteIcon, 'FormatQuote');
export const FormatSize = withTestId(FormatSizeIcon, 'FormatSize');
export const FormatUnderlined = withTestId(FormatUnderlinedIcon, 'FormatUnderlined');
export const ForumOutlined = withTestId(ForumOutlinedIcon, 'ForumOutlined');
export const Fullscreen = withTestId(FullscreenIcon, 'Fullscreen');
export const FullscreenExit = withTestId(FullscreenExitIcon, 'FullscreenExit');
export const GetApp = withTestId(GetAppIcon, 'GetApp');
export const Grain = withTestId(GrainIcon, 'Grain');
export const GraphicEq = withTestId(GraphicEqIcon, 'GraphicEq');
export const GridView = withTestId(GridViewIcon, 'GridView');
export const Help = withTestId(HelpIcon, 'Help');
export const HelpOutline = withTestId(HelpOutlineIcon, 'HelpOutline');
export const HelpOutlineRounded = withTestId(HelpOutlineRoundedIcon, 'HelpOutlineRounded');
export const Highlight = withTestId(HighlightIcon, 'Highlight');
export const HighlightOff = withTestId(HighlightOffIcon, 'HighlightOff');
export const History = withTestId(HistoryIcon, 'History');
export const Home = withTestId(HomeIcon, 'Home');
export const HomeOutlined = withTestId(HomeOutlinedIcon, 'HomeOutlined');
export const HourglassEmpty = withTestId(HourglassEmptyIcon, 'HourglassEmpty');
export const ImportContacts = withTestId(ImportContactsIcon, 'ImportContacts');
export const InfoOutlined = withTestId(InfoOutlinedIcon, 'InfoOutlined');
export const Insights = withTestId(InsightsIcon, 'Insights');
export const InsightsOutlined = withTestId(InsightsOutlinedIcon, 'InsightsOutlined');
export const JoinInner = withTestId(JoinInnerIcon, 'JoinInner');
export const KeyboardArrowDown = withTestId(KeyboardArrowDownIcon, 'KeyboardArrowDown');
export const KeyboardArrowRight = withTestId(KeyboardArrowRightIcon, 'KeyboardArrowRight');
export const KeyboardArrowUp = withTestId(KeyboardArrowUpIcon, 'KeyboardArrowUp');
export const KeyboardDoubleArrowLeft = withTestId(KeyboardDoubleArrowLeftIcon, 'KeyboardDoubleArrowLeft');
export const KeyboardDoubleArrowRight = withTestId(KeyboardDoubleArrowRightIcon, 'KeyboardDoubleArrowRight');
export const Label = withTestId(LabelIcon, 'Label');
export const Language = withTestId(LanguageIcon, 'Language');
export const LastPage = withTestId(LastPageIcon, 'LastPage');
export const LibraryBooksRounded = withTestId(LibraryBooksRoundedIcon, 'LibraryBooksRounded');
export const LightbulbCircleOutlined = withTestId(LightbulbCircleOutlinedIcon, 'LightbulbCircleOutlined');
export const LightbulbSharp = withTestId(LightbulbSharpIcon, 'LightbulbSharp');
export const Link = withTestId(LinkIcon, 'Link');
export const LinkOff = withTestId(LinkOffIcon, 'LinkOff');
export const List = withTestId(ListIcon, 'List');
export const LiveHelp = withTestId(LiveHelpIcon, 'LiveHelp');
export const Lock = withTestId(LockIcon, 'Lock');
export const LockOpen = withTestId(LockOpenIcon, 'LockOpen');
export const LockOutlined = withTestId(LockOutlinedIcon, 'LockOutlined');
export const LogoutOutlined = withTestId(LogoutOutlinedIcon, 'LogoutOutlined');
export const Menu = withTestId(MenuIcon, 'Menu');
export const Merge = withTestId(MergeIcon, 'Merge');
export const Message = withTestId(MessageIcon, 'Message');
export const MoreHoriz = withTestId(MoreHorizIcon, 'MoreHoriz');
export const MoreVert = withTestId(MoreVertIcon, 'MoreVert');
export const MyLocation = withTestId(MyLocationIcon, 'MyLocation');
export const Newspaper = withTestId(NewspaperIcon, 'Newspaper');
export const Note = withTestId(NoteIcon, 'Note');
export const OpenInBrowser = withTestId(OpenInBrowserIcon, 'OpenInBrowser');
export const OpenInFull = withTestId(OpenInFullIcon, 'OpenInFull');
export const OpenInNew = withTestId(OpenInNewIcon, 'OpenInNew');
export const Palette = withTestId(PaletteIcon, 'Palette');
export const PermDataSetting = withTestId(PermDataSettingIcon, 'PermDataSetting');
export const Person = withTestId(PersonIcon, 'Person');
export const PersonOutlined = withTestId(PersonOutlinedIcon, 'PersonOutlined');
export const PieChart = withTestId(PieChartIcon, 'PieChart');
export const PlaylistAdd = withTestId(PlaylistAddIcon, 'PlaylistAdd');
export const PollRounded = withTestId(PollRoundedIcon, 'PollRounded');
export const PowerSettingsNew = withTestId(PowerSettingsNewIcon, 'PowerSettingsNew');
export const PublicOutlined = withTestId(PublicOutlinedIcon, 'PublicOutlined');
export const PublishedWithChanges = withTestId(PublishedWithChangesIcon, 'PublishedWithChanges');
export const PublishedWithChangesOutlined = withTestId(
  PublishedWithChangesOutlinedIcon,
  'PublishedWithChangesOutlined'
);
export const RateReview = withTestId(RateReviewIcon, 'RateReview');
export const Refresh = withTestId(RefreshIcon, 'Refresh');
export const Remove = withTestId(RemoveIcon, 'Remove');
export const Reorder = withTestId(ReorderIcon, 'Reorder');
export const ReorderOutlined = withTestId(ReorderOutlinedIcon, 'ReorderOutlined');
export const RocketLaunch = withTestId(RocketLaunchIcon, 'RocketLaunch');
export const RocketLaunchOutlined = withTestId(RocketLaunchOutlinedIcon, 'RocketLaunchOutlined');
export const SaveAlt = withTestId(SaveAltIcon, 'SaveAlt');
export const School = withTestId(SchoolIcon, 'School');
export const Science = withTestId(ScienceIcon, 'Science');
export const Search = withTestId(SearchIcon, 'Search');
export const Send = withTestId(SendIcon, 'Send');
export const Settings = withTestId(SettingsIcon, 'Settings');
export const SettingsBackupRestore = withTestId(SettingsBackupRestoreIcon, 'SettingsBackupRestore');
export const SettingsOutlined = withTestId(SettingsOutlinedIcon, 'SettingsOutlined');
export const Share = withTestId(ShareIcon, 'Share');
export const ShoppingBasket = withTestId(ShoppingBasketIcon, 'ShoppingBasket');
export const ShowChart = withTestId(ShowChartIcon, 'ShowChart');
export const Sort = withTestId(SortIcon, 'Sort');
export const SortByAlpha = withTestId(SortByAlphaIcon, 'SortByAlpha');
export const Speed = withTestId(SpeedIcon, 'Speed');
export const StackedLineChart = withTestId(StackedLineChartIcon, 'StackedLineChart');
export const Star = withTestId(StarIcon, 'Star');
export const StarBorder = withTestId(StarBorderIcon, 'StarBorder');
export const StopCircle = withTestId(StopCircleIcon, 'StopCircle');
export const Storage = withTestId(StorageIcon, 'Storage');
export const StorageOutlined = withTestId(StorageOutlinedIcon, 'StorageOutlined');
export const Subject = withTestId(SubjectIcon, 'Subject');
export const SwapHoriz = withTestId(SwapHorizIcon, 'SwapHoriz');
export const SwapVert = withTestId(SwapVertIcon, 'SwapVert');
export const SyncAlt = withTestId(SyncAltIcon, 'SyncAlt');
export const SyncProblem = withTestId(SyncProblemIcon, 'SyncProblem');
export const Timeline = withTestId(TimelineIcon, 'Timeline');
export const Title = withTestId(TitleIcon, 'Title');
export const Tour = withTestId(TourIcon, 'Tour');
export const TourOutlined = withTestId(TourOutlinedIcon, 'TourOutlined');
export const TrackChanges = withTestId(TrackChangesIcon, 'TrackChanges');
export const TrendingUp = withTestId(TrendingUpIcon, 'TrendingUp');
export const Tune = withTestId(TuneIcon, 'Tune');
export const Update = withTestId(UpdateIcon, 'Update');
export const Upload = withTestId(UploadIcon, 'Upload');
export const VideoLibrary = withTestId(VideoLibraryIcon, 'VideoLibrary');
export const ViewColumn = withTestId(ViewColumnIcon, 'ViewColumn');
export const ViewInAr = withTestId(ViewInArIcon, 'ViewInAr');
export const ViewList = withTestId(ViewListIcon, 'ViewList');
export const ViewModule = withTestId(ViewModuleIcon, 'ViewModule');
export const ViewSidebar = withTestId(ViewSidebarIcon, 'ViewSidebar');
export const VisibilityOffRounded = withTestId(VisibilityOffRoundedIcon, 'VisibilityOffRounded');
export const VisibilityRounded = withTestId(VisibilityRoundedIcon, 'VisibilityRounded');
export const VpnKey = withTestId(VpnKeyIcon, 'VpnKey');
export const WarningOutlined = withTestId(WarningOutlinedIcon, 'WarningOutlined');
export const WifiOff = withTestId(WifiOffIcon, 'WifiOff');
export const WorkOutlined = withTestId(WorkOutlinedIcon, 'WorkOutlined');
